<div [hidden]="HideComponent">
  <div style="position:relative;">
    <div class="row-no-margin section-header-container">
      <div class="col-md-12 clear-padding">
        <span class="section-header">RMAs</span>
        <div class="row-no-margin">
          <div class="col-md-3 clear-padding">
            <mat-form-field appearance="fill">
              <mat-label>Filter by:</mat-label>
              <mat-select id="rmaSort" (selectionChange)="RMASort_Change($event)" [(value)]="RMASortValue">
                <mat-option value="received">
                  Received
                </mat-option>
                <mat-option value="status">
                  Status
                </mat-option>
                <mat-option value="shiptoname">
                  Ship to Name
                </mat-option>
                <mat-option value="issuedate">
                  Issue Date
                </mat-option>
                <mat-option value="evaldate">
                  Eval Date
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 clear-padding">
            <mat-form-field *ngIf="CurUser.IsTolomaticUser" appearance="fill">
              <mat-label>Distributor:</mat-label>
              <mat-select id="orderDistributor" (selectionChange)="Dist_Change($event)" [value]="CurrentDist">
                <mat-option *ngFor="let dist of DistList" [value]="dist.CompanyId">
                  {{dist.Company}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3 clear-padding" style="text-align: right;; line-height: 80px;">
            <a class="clickable blue" (click)="ViewFullDetails()">View all RMAs</a>
          </div>

        </div>


      </div>

    </div>
    <div>
      <table style="width:100%;">
        <tr>
          <th>RMA Number</th>
          <th style="text-align:center;">Issue Date</th>
          <th style="text-align:center;">Ship to Name</th>
          <th style="text-align:center;">Customer PO</th>
          <th style="text-align:center;">Status</th>
          <th style="text-align:center;">Actions</th>
        </tr>
        <ng-container *ngFor="let rma of RMAList">
          <tr>
            <td>
              <button mat-icon-button aria-label="expand row" (click)="(rma.Expanded = !rma.Expanded); LoadDetails(rma); $event.stopPropagation()">
                <mat-icon *ngIf="!rma.Expanded" class="blue-color">keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="rma.Expanded" class="blue-color">keyboard_arrow_up</mat-icon>
              </button>
              {{rma.RMANumber}}
            </td>
            <td style="text-align:center;">
              {{rma.ReceiptDate  | date:'M/d/y'}}
            </td>
            <td [matTooltip]="rma.ShipToName" style="text-align:center;">
              {{rma.ShortShipTo}}
            </td>
            <td style="text-align:center;">
              {{rma.PONumber}}
            </td>
            <td style="text-align:center;">
              {{rma.RMAStatus}}
            </td>
            <td style="text-align:center;">

              <span *ngIf="rma.RMAEvalPath.length > 0" (click)="ViewRMAEval(rma)" class="clickable blue-color"><fa-icon [icon]="faEye" class="clickable blue-color"></fa-icon>&nbsp;View Eval</span>
            </td>
          </tr>
          <!--Expanded content column-->
          <ng-container *ngIf="rma.Expanded">
            <tr>
              <td colspan="6">
                <table class="sub-table" style="width:100%;">
                  <tr>
                    <th></th>
                    <!--<th>Item</th>-->
                    <th>Description</th>
                    <th style="text-align:center;">Qty</th>
                    <th style="text-align:center;">Status</th>
                    <th style="text-align:center;">Eval Code</th>
                    <th style="text-align:center;">Repair Order</th>
                    <!--<th>Reason</th>-->
                    <th style="text-align:center;">Ship Date</th>
                    <th style="text-align:center;">Followed</th>
                  </tr>
                  <ng-container *ngFor="let RMAItem of rma.RMAItems">
                    <tr>
                      <td style="text-align:center;">
                        {{RMAItem.RMALine}}
                      </td>
                      <!--<td>
                        {{RMAItem.Item}}
                      </td>-->
                      <td [matTooltip]="RMAItem.Description">
                        {{RMAItem.ShortDesc}}
                      </td>
                      <td style="text-align:center;">
                        {{RMAItem.Quantity}}
                      </td>
                      <td style="text-align:center;">
                        <span class="clickable blue-color" (click)="OpenRMAItem(rma, RMAItem)">{{GetRMAItemStatusText(RMAItem)}}</span>
                      </td>
                      <td style="text-align:center;">
                        {{RMAItem.EvalDesc}}
                      </td>
                      <td style="text-align:center;">
                        {{RMAItem.RepairOrder}}
                      </td>
                      <!--<td [matTooltip]="RMAItem.Reason" style="display:inline-block;height:40px;line-height:2.5;width:200px;overflow:hidden; white-space:nowrap;text-overflow:ellipsis;">
                        {{RMAItem.ShortReason}}
                      </td>-->
                      <td style="text-align:center;">
                        {{RMAItem.ShipDate  | date:'M/d/y'}}
                      </td>
                      <td style="text-align:center;">
                        <app-toggle [initial]="RMAItem.Followed" [idForControl]="RMAItem.RMAItemRowPointer" [trueText]="" [falseText]="" (changed)="FollowOrder($event,RMAItem.RMAItemRowPointer)"></app-toggle>
                      </td>
                    </tr>
                  </ng-container>
                </table>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </table>
    </div>
    <div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
      <div style="position:absolute;top:45%;left:45%;">
        <mat-spinner mode="indeterminate"></mat-spinner>
      </div>
    </div>
  </div>
  <app-modal hidden="true"></app-modal>
</div>
